import React from 'react';
import { nextFutureDate, previousPastDate } from '../../../common/lib/dates';
import { formatDateAndTime, formatTime } from '../../../common/lib/formatDate';
import type { RealestateAd, RealestateProjectAd } from '../../../types';

const c = {
    pill: 'inline-block px-8 py-4 text-xs border s-border rounded-full',
};

type ViewingTimesProps = {
    ad: RealestateAd | RealestateProjectAd;
    className?: string;
};

export function ViewingTimes(props: ViewingTimesProps) {
    const { ad, className = '' } = props;

    const { viewing_times, flags } = ad;

    if (flags?.includes('coming_for_sale')) {
        return null;
    }

    if (viewing_times && viewing_times.length) {
        const nextViewing = computeNextViewing(viewing_times);

        const viewingToday = Boolean(
            flags?.includes('viewingtoday') &&
                !flags.includes('sold') &&
                !flags.includes('rentedout'),
        );

        if (nextViewing) {
            return (
                <div className={className}>
                    <span className={c.pill}>
                        {viewingToday
                            ? `Visning i dag ${formatTime(nextViewing)}`
                            : `Visning - ${formatDateAndTime(nextViewing)}`}
                    </span>
                </div>
            );
        }
    }

    return (
        <div className={className}>
            <span className={c.pill}>Visning etter avtale</span>
        </div>
    );
}

function computeNextViewing(viewing_times: string[]) {
    const dates = viewing_times.map((vt) => new Date(vt));

    const midnightToday = new Date();
    midnightToday.setHours(0, 0, 0, 0);

    const previousViewingToday = previousPastDate(dates, midnightToday);
    const nextFutureViewing = nextFutureDate(dates);

    return previousViewingToday ?? nextFutureViewing;
}
